import { PartnerRoles } from "@/models/partnerUsers";
import { AxiosResponse } from "axios";
import { httpClient } from "./API";

export const getAllPartnerRolesAPI = async (): Promise<
  AxiosResponse<PartnerRoles[]>
> => {
  return httpClient.get("/core/internal/calgary/partnerRoles/");
};
